<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="600"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :rules="rules"
      :model="port_data"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <el-alert class="mb-2" type="info" show-icon :closable="false">
          <p class="ma-0">Charger Port :</p>
          <el-text tag="i" v-if="port_data.id != 0">
            The update will be performed after the flowchart is reviewed. This
            may take a few minutes.
          </el-text>
        </el-alert>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item prop="port_id" label="Port ID: ">
              <el-input v-model="port_data.port_id" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item prop="port_type" label="Port Type: ">
              <el-input v-model="port_data.port_type" />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item prop="port_capacity_kw" label="Port Capacity kw: ">
              <el-input v-model="port_data.port_capacity_kw" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="description" label="Description: ">
              <el-input v-model="port_data.description" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
    </el-form>
    <!-- </el-row> -->
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="confirm"
          color="#0D3937"
        >
          <i class="fa fa-check me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Confirm</span>
        </el-button>
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i><span class="moderat-btn-apply">Cancel</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
  <ShowModifyQuestions
    :open_modal="show_modify_modal"
    :port_modal="modify_port_modal"
    :primary_modal="primary_modal"
    @close_modal="modify_close_modal"
    @question_priority="questionPriority"
  />
</template>

<script>
// import "animate.css";
import UserService from "../../services/user.service";
// import moment from "moment";
import ShowModifyQuestions from "./dialogModifyQuestions.vue";
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      // eslint-disable-next-line no-unused-vars
      default(rawProps) {
        return rawProps;
      },
    },
  },
  components: {
    ShowModifyQuestions,
  },
  data() {
    return {
      show: this.open_modal,
      show_modify_modal: false,
      modify_port_modal: null,
      primary_modal: null,
      rules: {
        port_id: {
          required: true,
          message: "Please enter port id.",
          trigger: "blur",
        },
        port_type: {
          required: true,
          message: "Please enter port type.",
          trigger: "blur",
        },
        port_capacity_kw: {
          type: "integer",
          trigger: "blur",
          asyncValidator: (rule, value) => {
            console.log(value);
            return new Promise((resolve, reject) => {
              if (!(value >= 1 && value <= 1000)) {
                reject("port capacity kW must be between 1 and 1000"); // reject with error message
              } else {
                resolve();
              }
            });
          },
        },
      },
      port_data: {
        charger_id: 0,
        port_id: "",
        port_type: "",
        port_capacity_kw: 0,
        description: "",
        id: 0,
      },
      question_priority: [],
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      this.show = newVal;
      if (newVal == true) {
        this.port_data = JSON.parse(this.data_modal);
        this.primary_modal = JSON.stringify(this.port_data);
        // console.log(this.port_data);
      }
    },
  },
  methods: {
    isNewUser() {
      if (this.port_data.id == 0) return true;
      else return false;
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
    modify_close_modal() {
      this.show_modify_modal = false;
    },
    questionPriority(event) {
      this.question_priority = event;
      var bodyRequest = {
        port: this.port_data,
        question_priority: this.question_priority,
      };
      UserService.updatePort(bodyRequest)
        .then(
          (response) => {
            this.modify_close_modal();
            this.$emit("confirm_modal", response.data.port);
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    async confirm() {
      await this.$refs["ruleFormRef"].validate((valid, fields) => {
        if (valid) {
          this.modify_port_modal = this.port_data;
          this.show_modify_modal = true;
          // UserService.updatePort(this.port_data)
          //   .then(
          //     (response) => {
          //       this.$emit("confirm_modal", response.data.port);
          //     },
          //     (error) => {
          //       this.loading = false;
          //       console.log(error);
          //       if (error.response.status == 401) {
          //         this.$router.push({
          //           path: "/",
          //         });
          //       }
          //     }
          //   )
          //   .catch((error) => {
          //     this.loading = false;
          //     console.log(error);
          //     if (error.response.status == 401) {
          //       this.$router.push({
          //         path: "/",
          //       });
          //     }
          //   })
          //   .finally(() => (this.loading = false));
        } else {
          console.log("error submit!", fields);
        }
      });
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    isValidDate(dateString) {
      const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (dateRegex.test(dateString)) {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding: 30px 10px;
}
.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {

  margin-bottom: 0 !important;
}
.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.dtp-customer > .el-input__wrapper {
  padding: 0 10px !important;
  height: 32px !important;
}
</style>
